import * as React from 'react';

/**
 * Re-renders the subscribing component on an interval, so time-derived
 * benefit states (open windows, countdowns, the today line) stay honest on a
 * page left open across a day or window boundary. Components keep calling
 * DateTime.now() during render; this hook only schedules the renders.
 */
export const useNowTick = (intervalMs = 60_000): void => {
  const [, setTick] = React.useState(0);
  React.useEffect(() => {
    const id = setInterval(() => setTick((tick) => tick + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
};
